<script setup>
import { computed } from 'vue';
import TaskCard from './TaskCard.vue';
import { STATUSES } from '../utils/taskMeta';

const props = defineProps({
  tasks: { type: Array, default: () => [] },
});
defineEmits(['edit']);

const columns = computed(() =>
  STATUSES.map(s => ({
    ...s,
    items: props.tasks.filter(t => t.status === s.value),
  }))
);
</script>

<template>
  <div class="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
    <div
      v-for="col in columns"
      :key="col.value"
      class="flex flex-col rounded-xl border border-n-strong/40 bg-n-slate-2/60 p-3"
    >
      <div class="mb-3 flex items-center justify-between">
        <div class="flex items-center gap-2">
          <span
            class="rounded-md px-2 py-0.5 text-[11px] font-bold"
            :class="[col.color]"
          >
            {{ col.label }}
          </span>
          <span class="text-[11px] text-n-slate-11">{{
            col.items.length
          }}</span>
        </div>
      </div>

      <div class="flex-1 space-y-2">
        <TaskCard
          v-for="t in col.items"
          :key="t.id"
          :task="t"
          @edit="$emit('edit', t)"
        />

        <div
          v-if="!col.items.length"
          class="rounded-lg border border-dashed border-n-weak py-8 text-center text-[11px] text-n-slate-11"
        >
          Sem tarefas
        </div>
      </div>
    </div>
  </div>
</template>
